import "@arco-design/web-react/es/Select/style";
import _Select from "@arco-design/web-react/es/Select";
import React from 'react';
export const SelectDuration = ({
  value,
  onChange,
  placeholder = '全部'
}) => {
  const options = [{
    label: '00:05-04:05',
    value: '00:05-04:05'
  }, {
    label: '04:05-08:05',
    value: '04:05-08:05'
  }, {
    label: '08:05-12:05',
    value: '08:05-12:05'
  }, {
    label: '12:05-16:05',
    value: '12:05-16:05'
  }, {
    label: '16:05-20:05',
    value: '16:05-20:05'
  }, {
    label: '20:05-24:00',
    value: '20:05-24:00'
  }];
  return /*#__PURE__*/React.createElement(_Select, {
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    options: options,
    allowClear: true
  });
};